import Label from "components/general/Label";
import React, { useMemo, useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useViewport } from 'components/general/useViewPort';
import MirsTable from "components/general/table/Table";
import { rotationColumns } from "../events/common/columns";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import NotAvailable from "components/common/NotAvailable";
import { TableExpandedIndivual, TableExpandedGroups } from "../events/common/TableExpandedRotations";
import { isFinal, isGroups } from "../helpers/GryHelpers";
import SportCode from "components/common/SportCode";
import Status from "components/presentation/Status";


const GryRotations = ({ data, currentRotation }) => {
    const [activeKey, setActiveKey] = useState(currentRotation);
    const { mirs_discipline, mirs_event_rsc} = useUrlFriendlyToParameters()

    
    useEffect(() => {
        setActiveKey(currentRotation)
    }, [currentRotation])


    let elements = data.map(item => {
        const rotation = item?.data.results?.eventUnitCode?.slice(-1)
        const appCode = (isFinal(item?.data.results?.eventUnitCode) || isGroups(item?.data.results?.eventUnitCode)) && item?.data.results?.items ? item?.data.results?.items[0]?.eventUnitEntries?.find(eue => eue?.eue_code === 'APPARATUS')?.eue_value : '';
        const apparatus = appCode ? <> - <SportCode discipline={mirs_discipline} entity='@Apparatus' code={appCode} /></> : <></>;
        const status = <Status typeToPrint={'result'} scheduleStatus={item?.data.results?.schedule?.status?.code} resultStatus={item?.data.results?.status?.description} />

        return (
            <Accordion.Item key={`mirs-rotation-item-${rotation}`} eventKey={rotation} >
                <Accordion.Header className={`${currentRotation === rotation ? 'active' : ''}`}><RotationHeader leftCol={<><Label data={'HeaderRotation'} /> {rotation} {apparatus}</>} rightCol={status} /></Accordion.Header>
                <Accordion.Body>
                    <Rotation data={item?.data}/>
                </Accordion.Body>
            </Accordion.Item>
        )
    })

    return (
        <Accordion activeKey={activeKey} onSelect={rotation => setActiveKey(rotation)} >
            {elements}
        </Accordion>
    )
};

export default GryRotations;

const Rotation = ({ data }) => {
    
    const {breakPoint} = useViewport();
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const resultStatus = data?.results?.status?.code;  
    const renderRowSubComponent = React.useCallback(({ row }) => {
        let componentExpanded = isGroups(mirs_rsc) ? <TableExpandedGroups row={row?.original} status={data?.results?.status?.code}/> : <TableExpandedIndivual row={row?.original} status={data?.results?.status?.code}/>
        return (
          <LoaderSubComponent component={componentExpanded} />
        )
      },
     [resultStatus]
    );

    if (!data?.results?.items) return <NotAvailable />;

    let current = data?.results?.items?.filter(item => item?.extendedResultsCurrent)?.find(item => item?.extendedResultsCurrent?.find(erc => erc?.er_code === 'STAGE' && erc?.er_value === 'CURRENT'));

    const isStartList = isStartListStatus(resultStatus);
      
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const getColumns = () => {
        let columns = rotationColumns();
        return columns;    
    }

    const getInitialSortBy = () => {
      let initialSortBy = [{ id: 'StartOrder', desc: false }];      
      return initialSortBy;
    }

    const getHiddenColumns = () => {
      let apparatus = isFinal(mirs_rsc) || isGroups(mirs_rsc) ? ['Apparatus'] : []
      let startOrder = isMobile ? ['StartOrder'] : []
      return [...startOrder, ...apparatus]
    }

    const getCurrentIndicator = (row) => {
        const isCurrent = current?.participant?.code === row?.original?.participant?.code;
        return {className: isCurrent ? 'currentIndicator' : ''}
    }

    return (
        <MirsTable
        id={`mirs-table-result-${mirs_rsc}`}
        sortable={!isMobile}
        data={data?.results?.items}
        columns={getColumns()}
        keyRow={"participant-code"}
        initialSortBy={getInitialSortBy()}
        hiddenColumns={getHiddenColumns()}
        renderRowSubComponent={renderRowSubComponent}
        getRowProps={row => { return getCurrentIndicator(row) }}
    />)
}

const RotationHeader = ({ leftCol, rightCol }) => {
    return (
        <div className="w-100 d-flex justify-content-between navbar-light">
            <div className="p-2">
                {leftCol}
            </div>
            <div className="p-2">
                {rightCol}
            </div>
        </div>
    );
}